<template>
  <div class="cover-content table-wrapper">
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right"
    >
      <Row :gutter="16">
        <Col span="2">
          <Button type="primary" @click="handleExport" icon="ios-exit-outline"
            >导出</Button
          >
        </Col>
        <Col span="6">
          <FormItem label=""></FormItem>
        </Col>
        <Col span="6" :offset="6">
          <FormItem label="日期:">
            <DatePicker
              v-model="formInline.起始日期"
              type="daterange"
              placeholder="请选择起始日期"
              @on-change="handleChangeDate"
              split-panels
            ></DatePicker>
          </FormItem>
        </Col>
        <!-- <Col span="6">
                <FormItem label="数据对接标准:">
                <Select v-model="formInline.dataStandard" placeholder="请选择数据对接标准">
                    <Option v-for="(item, index) in selList" :value="item.value" :key="`sel-it-` + index">{{ item.label }}</Option>
                </Select>
                </FormItem>
            </Col> -->

        <Col span="4">
          <Button style="margin-left: 20px;float:right;" @click="handleReset"
            >重置</Button
          >
          <Button style="float:right;" type="primary" @click="handleQuery"
            >搜索</Button
          >
          <!-- <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span> -->
        </Col>
      </Row>
    </Form>
    <div class="ft-box" style="margin-bottom: 0px;">
      <Table
        border
        size="large"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="dataStandard">
          <a :href="hrefPath" target="_blank">{{ row.dataStandard }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button
            class="table-btn"
            type="text"
            size="small"
            @click="handleDeal(row)"
            >详情</Button
          >
        </template>
      </Table>
      <div class="t-page">
        <Page
          :total="totalCount"
          :page-size="pageSize"
          :current="page"
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
          show-elevator
          show-sizer
          show-total
          transfer
        >
        </Page>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import tableMixin from "@/components/tableMixin";
export default {
  mixins: [tableMixin],
  data() {
    return {
      loading: false,
      hrefPath:
        process.env.BASE_URL +
        "file/陕西省城乡建设厅建筑工人实名制数据接口标准V1.5(试行版).docx",
      selList: [
        {
          label: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
          value: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
        },
        {
          label: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
          value: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
        },
        {
          label: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
          value: "陕西省城乡建设厅建筑工人实名制数据接口标准V1.3(试行版)",
        },
      ],
      formInline: {
        起始日期: "",
        areaCode: "",
        current: 1,
        endDate: "",
        dataStandard: "", // 数据对接标准
        size: 10,
        startDate: "",
      },
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "数据来源",
          key: "dataSource",
        },
        {
          title: "数据推送时间",
          key: "pushTime",
        },
        {
          title: "数据总条数",
          key: "totalNum",
          align: "right",
          width: 150,
        },
        {
          title: "数据类型",
          key: "dataType",
        },
        {
          title: "数据对接标准",
          slot: "dataStandard",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 70,
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  created() {
    this.formInline.areaCode = this.$route.query.areaCode;
    // this.getPageData();
  },
  mounted() {},
  watch: {},
  methods: {
    handleQuery() {
      this.page = 1;
      this.getTableData();
    },
    handleChangeDate(val) {
      this.formInline.startDate = val[0];
      this.formInline.endDate = val[1];
    },
    handleReset() {
      this.page = 1;
      this.pageSize = 10;
      this.formInline = {
        起始日期: "",
        areaCode: this.$route.query.areaCode,

        endDate: "",
        dataStandard: "", // 数据对接标准
        startDate: "",
      };
      this.getTableData();
    },
    /*获取表格数据*/
    getTableData() {
      const { areaCode, endDate, dataStandard, startDate } = this.formInline;
      this.loading = true;
      this.axios({
        method: "post",
        url: "/dataSource/sx/list/detail",
        data: {
          areaCode,
          current: this.page,
          endDate,
          dataStandard,
          size: this.pageSize,
          startDate,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.success) {
            this.totalCount = response.data.data.total;
            this.tableData = response.data.data.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //导出
    handleExport() {
      const { areaCode, endDate, dataStandard, startDate } = this.formInline;
      this.axios({
        method: "post",
        url: "/dataSource/sx/detail/export",
        responseType: "arraybuffer",
        data: {
          areaCode,
          current: this.page,
          endDate,
          dataStandard,
          size: this.pageSize,
          startDate,
        },
      }).then((response) => {
        this.common.download(
          response,
          "数据来源详情.xls",
          "application/vnd.ms-excel"
        );
      });
    },
    handleDeal(row) {
      console.log(row);
      let name = "";
      switch (row.dataType) {
        /*参建单位*/
        case "参建单位数据":
          name = "participatingUnits";
          break;
        /*项目基本信息*/
        case "项目数据":
          name = "projectData";
          break;
        /*设计*/
        case "企业数据":
          name = "enterpriseData";
          break;
        /*班组数据*/
        case "班组数据":
          name = "temaData";
          break;
        /*人员进退场*/
        case "人员进退场数据":
          name = "PersonnelEntryExitData";
          break;
        /*项目人员合同*/
        case "人员合同数据":
          name = "projectPersonalContract";
          break;
        /*项目人员合同*/
        case "人员考勤数据":
          name = "attendancePersonnel";
          break;
        case "人员工资数据":
          name = "projectpersonnelSalary";
          break;
        case "培训数据":
          name = "projectTraining";
          break;
        case "人员数据":
          name = "personData";
          break;
      }
      this.$router.push({
        name,
        query: {
          areaCode: row.areaCode,
          row,
        },
      });
    },
  },
};
</script>
